import React, { useCallback, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@tds/core-box';
import styled from 'styled-components';
import { colorGreyGainsboro, colorWhite as colorWhite$2 } from '@tds/core-colours';
import { safeRest, DependentIconSizeContext } from '@tds/util-helpers';
import { media } from '@tds/core-responsive';
import Paragraph from '@tds/core-paragraph';
import { Delete, IconButton, Close } from '@tds/core-interactive-icon';
import { withForwardedRef, withFocusTrap } from '@tds/shared-hocs';
import Button from '@tds/core-button';
import Heading from '@tds/core-heading';

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles = _arrayWithHoles;

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit = _iterableToArrayLimit;

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var nonIterableRest = _nonIterableRest;

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties = _objectWithoutProperties;

function createCommonjsModule$1(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$1 = createCommonjsModule$1(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

// colours
var colorWhite = '#fff'; // grey

var colorGreyShark = '#2a2c2e';
var colorText = colorGreyShark; // tokens

var fontTelus = '"TELUS-Web", "Helvetica Neue", Helvetica, Arial, sans-serif';
var helveticaNeueThin35 = {
  fontWeight: 300
};
var helveticaNeueLight45 = {
  fontWeight: 400
};
var helveticaNeueRoman55 = {
  fontWeight: 500
};
var helveticaNeueMedium65 = {
  fontWeight: 700
};
var sizeSmall = {
  fontSize: '0.875rem',
  letterSpacing: -0.6,
  lineHeight: '1.42857'
};
var sizeMedium = {
  fontSize: '1rem',
  letterSpacing: -0.8,
  lineHeight: '1.5'
};
var sizeLarge = {
  fontSize: '1.25rem',
  letterSpacing: -1,
  lineHeight: '1.6'
};
var wordBreak = {
  wordWrap: 'break-word'
};
var baseSupSubScripts = {
  position: 'relative',
  verticalAlign: 'baseline',
  paddingLeft: '0.1em'
};
var sup = _extends_1$1({
  top: '-0.5em',
  fontSize: '0.875rem'
}, baseSupSubScripts);
var base = _extends_1$1({}, wordBreak, {
  fontSize: 'inherit'
});
var baseFont = {
  fontWeight: 'inherit'
};
var small = _extends_1$1({}, wordBreak, sizeSmall);
var smallFont = _extends_1$1({}, helveticaNeueRoman55);
var medium = _extends_1$1({}, wordBreak, sizeMedium);
var mediumFont = _extends_1$1({}, helveticaNeueLight45);
var large = _extends_1$1({}, wordBreak, sizeLarge);
var largeFont = _extends_1$1({}, wordBreak, helveticaNeueLight45);
var boldFont = _extends_1$1({}, wordBreak, helveticaNeueMedium65);
var color = {
  color: colorText
};
var invertedColor = {
  color: colorWhite
};
var blockText = {
  display: 'block'
};



var typography = /*#__PURE__*/Object.freeze({
	__proto__: null,
	base: base,
	baseFont: baseFont,
	baseSupSubScripts: baseSupSubScripts,
	blockText: blockText,
	boldFont: boldFont,
	color: color,
	fontTelus: fontTelus,
	helveticaNeueLight45: helveticaNeueLight45,
	helveticaNeueMedium65: helveticaNeueMedium65,
	helveticaNeueRoman55: helveticaNeueRoman55,
	helveticaNeueThin35: helveticaNeueThin35,
	invertedColor: invertedColor,
	large: large,
	largeFont: largeFont,
	medium: medium,
	mediumFont: mediumFont,
	sizeLarge: sizeLarge,
	sizeMedium: sizeMedium,
	sizeSmall: sizeSmall,
	small: small,
	smallFont: smallFont,
	sup: sup,
	wordBreak: wordBreak
});

var thin = {
  borderWidth: 1,
  borderStyle: 'solid'
};
var none = {
  borderWidth: '0'
};
var rounded = {
  borderRadius: '4px'
};
var circular = {
  borderRadius: '50%'
};

var borders = /*#__PURE__*/Object.freeze({
  thin: thin,
  none: none,
  rounded: rounded,
  circular: circular
});

/* eslint-disable import/prefer-default-export */

/*
By default, browsers outline links in their own way. (Chrome/Safari do a light blue outline, Firefox/IE do a dotted line, etc)
Firefox also uses the text color for the outline, causing it to be invisible for primary and secondary ButtonLinks.

So, reset the outlines to fix Firefox and use browser defaults.

Solution from here: https://stackoverflow.com/questions/7538771/what-is-webkit-focus-ring-color
*/
var focusOutline = {
  ':focus': {
    // outline: 'dotted 1px Highlight', // TOOD: cannot have duplicate keys with style-objects.
    outline: 'auto 5px -webkit-focus-ring-color'
  }
};

var links = /*#__PURE__*/Object.freeze({
  focusOutline: focusOutline
});

/* eslint-disable import/prefer-default-export */
var noSpacing = {
  padding: 0,
  margin: 0
};

var spacing = /*#__PURE__*/Object.freeze({
  noSpacing: noSpacing
});
var font = {
  fontFamily: fontTelus
};

function createCommonjsModule$2(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$2 = createCommonjsModule$2(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

/* eslint-disable import/prefer-default-export */
var base$1 = {
  '&': {
    paddingLeft: '3rem'
  },
  '& &': {
    marginTop: '1rem',
    marginBottom: '0.5rem'
  }
};
var nestedListSpacing = _extends_1$2({}, base$1, {
  '& :last-child &': {
    marginBottom: 0
  }
});

/* eslint-disable import/prefer-default-export */

var noStyle = _extends_1$2({}, noSpacing, none, font, color, {
  appearance: 'none',
  background: 'none',
  boxShadow: 'none',
  cursor: 'pointer'
});

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose$1 = _objectWithoutPropertiesLoose$1;

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties$1 = _objectWithoutProperties$1;

function createCommonjsModule$3(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$3 = createCommonjsModule$3(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var baseStyle = {
  transform: 'rotate(-0.00001deg)',
  flexShrink: 0
};

var horizontalStyle = _extends_1$3({}, baseStyle, {
  width: '100%',
  height: '1px'
});

var verticalStyle = _extends_1$3({}, baseStyle, {
  display: 'inline-block',
  width: '1px'
});

var StyledHairlineDivider = styled.hr.withConfig({
  displayName: "HairlineDivider__StyledHairlineDivider",
  componentId: "biamlk-0"
})(spacing.noSpacing, borders.none, function (props) {
  if (props.vertical && props.gradient) {
    return _extends_1$3({}, verticalStyle, {
      'background-image': "\n        linear-gradient(0deg, rgba(216, 216, 216, 0) 0%,\n        ".concat(colorGreyGainsboro, " 12%,\n        ").concat(colorGreyGainsboro, " 88%,\n        rgba(216, 216, 216, 0) 100%)\n      ")
    });
  }

  if (props.vertical && !props.gradient) {
    return _extends_1$3({}, verticalStyle, {
      'background-color': colorGreyGainsboro
    });
  }

  if (!props.vertical && props.gradient) {
    return _extends_1$3({}, horizontalStyle, {
      'background-image': "\n        linear-gradient(90deg, rgba(216, 216, 216, 0) 0%,\n        ".concat(colorGreyGainsboro, " 7%,\n        ").concat(colorGreyGainsboro, " 93%,\n        rgba(216, 216, 216, 0) 100%)\n      ")
    });
  }

  return _extends_1$3({}, horizontalStyle, {
    'background-color': colorGreyGainsboro
  });
});
/**
 * Separate content within modules.
 *
 * @version ./package.json
 */

var HairlineDivider = function HairlineDivider(_ref) {
  var vertical = _ref.vertical,
      gradient = _ref.gradient,
      rest = objectWithoutProperties$1(_ref, ["vertical", "gradient"]);

  return React.createElement(StyledHairlineDivider, _extends_1$3({}, safeRest(rest), {
    vertical: vertical,
    gradient: gradient
  }));
};

HairlineDivider.propTypes = {
  /**
   * Draw the divider vertically.
   */
  vertical: PropTypes.bool,

  /**
   * Use a subtle gradient instead of a solid thin line.
   */
  gradient: PropTypes.bool
};
HairlineDivider.defaultProps = {
  vertical: false,
  gradient: false
};

var thin$1 = {
  borderWidth: 1,
  borderStyle: 'solid'
};
var none$1 = {
  borderWidth: '0'
};
var rounded$1 = {
  borderRadius: '4px'
};
var circular$1 = {
  borderRadius: '50%'
};

var borders$1 = /*#__PURE__*/Object.freeze({
  thin: thin$1,
  none: none$1,
  rounded: rounded$1,
  circular: circular$1
});

/* eslint-disable import/prefer-default-export */
var noSpacing$1 = {
  padding: 0,
  margin: 0
};

var spacing$1 = /*#__PURE__*/Object.freeze({
  noSpacing: noSpacing$1
});

function createCommonjsModule$4(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$4 = createCommonjsModule$4(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});
var font$1 = {
  fontFamily: fontTelus
};
var baseButton = _extends_1$4({
  margin: 0,
  padding: '0 2rem',
  cursor: 'pointer',
  background: 'none',
  transition: 'background 0.2s',
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  minHeight: '3.25rem'
}, media.from('md').css({
  display: 'inline-flex',
  width: 'auto',
  minWidth: '180px'
}), {
  // this is to fix the IE 11 bug to center text. For more info: https://github.com/philipwalton/flexbugs/issues/231
  '&:after': {
    content: "\"\"",
    minHeight: 'inherit',
    fontSize: 0
  }
});

/* eslint-disable import/prefer-default-export */
var base$2 = {
  '&': {
    paddingLeft: '3rem'
  },
  '& &': {
    marginTop: '1rem',
    marginBottom: '0.5rem'
  }
};
var nestedListSpacing$1 = _extends_1$4({}, base$2, {
  '& :last-child &': {
    marginBottom: 0
  }
});

/* eslint-disable import/prefer-default-export */

var noStyle$1 = _extends_1$4({}, noSpacing$1, {}, none$1, {}, font$1, {}, color, {
  appearance: 'none',
  background: 'none',
  boxShadow: 'none',
  cursor: 'pointer'
});

function createCommonjsModule$5(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$5 = createCommonjsModule$5(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

var StyledDimpleDivider = styled.hr.withConfig({
  displayName: "DimpleDivider__StyledDimpleDivider",
  componentId: "quxnvh-0"
})(spacing$1.noSpacing, borders$1.none, {
  height: '32px',
  backgroundImage: 'radial-gradient(ellipse at top, rgba(150, 150, 150, 0.1) 0%, rgba(0, 0, 0, 0) 70%)'
});
/**
 * Separate modules.
 *
 * @version ./package.json
 */

var DimpleDivider = function DimpleDivider(_ref) {
  var rest = _extends_1$5({}, _ref);

  return React.createElement(StyledDimpleDivider, safeRest(rest));
};

function createCommonjsModule$6(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule$6(function (module) {
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;
});

var componentWithName = function componentWithName(passedName, checkDisplayName) {
  if (typeof passedName !== 'string') {
    throw new Error('passedName must be a string');
  }

  var checkProp = function checkProp(props, propName, componentName) {
    if (typeof props[propName] === 'undefined' || props[propName] === null) {
      return undefined;
    }

    if (Array.isArray(props[propName])) {
      // Iterates through every child and try to find the first element that does not match the passed name
      // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Boolean
      return props[propName].map(function (_, index) {
        return checkProp(props[propName], index, componentName);
      }).find(Boolean);
    }

    var testNameInObject = function testNameInObject() {
      return _typeof_1(props[propName]) === 'object' && (!checkDisplayName && props[propName].type.name !== passedName || checkDisplayName && props[propName].type.displayName !== passedName);
    };

    var testNameInFunction = function testNameInFunction() {
      return typeof props[propName] === 'function' && (!checkDisplayName && props[propName].name !== passedName || checkDisplayName && props[propName].displayName !== passedName);
    };

    if (props[propName] && _typeof_1(props[propName]) !== 'object' && typeof props[propName] !== 'function' || testNameInObject() || testNameInFunction()) {
      return new Error("".concat(componentName, ": Component passed to `").concat(propName, "` prop should be ").concat(passedName));
    }

    return undefined;
  };

  var checkRequired = function checkRequired(props, propName, componentName) {
    if (props[propName] === undefined) {
      return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is ").concat(props[propName], "."));
    }

    return undefined;
  };

  var createValidate = function createValidate(isRequired) {
    if (isRequired) {
      return function (props, propName, componentName) {
        var checkForError = checkProp(props, propName, componentName);

        if (checkForError) {
          return checkForError;
        }

        return checkRequired(props, propName, componentName);
      };
    }

    return checkProp;
  };

  var validate = createValidate();
  validate.isRequired = createValidate(true);
  return validate;
};

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose$2 = _objectWithoutPropertiesLoose$2;

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties$2 = _objectWithoutProperties$2;

function createCommonjsModule$7(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$6 = createCommonjsModule$7(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

// colours
var colorGainsboro = '#d8d8d8';
var colorWhite$1 = '#fff'; // grey

var colorGreyShark$1 = '#2a2c2e';
var colorGreyRaven = '#71757b';

/* eslint-disable import/prefer-default-export */
var warn = function warn(componentName, message) {
  if (process.env.NODE_ENV === 'production') {
    return;
  }

  console.warn("[TDS] ".concat(componentName, ": ").concat(message)); // eslint-disable-line no-console
};

var base$3 = _extends_1$6({}, links.focusOutline, {
  '&:link,&:visited': {
    color: colorGreyShark$1,
    textDecoration: 'underline'
  },
  '&:hover': {
    textDecoration: 'none'
  },
  '& svg': {}
});

var states = function states(_ref) {
  var invert = _ref.invert;
  return {
    '&:active': {
      color: invert && colorGainsboro,
      backgroundColor: invert ? 'rgba(0,0,0,0.4)' : colorGainsboro,
      borderRadius: '0.25rem',
      padding: '0.125rem',
      margin: '-0.125rem',
      textDecoration: 'underline'
    },
    '&:focus': {
      border: "0.125rem solid ".concat(invert ? colorWhite$1 : colorGreyRaven),
      padding: '0.125rem',
      margin: '-0.25rem',
      // (border + padding) * -1
      borderRadius: '0.25rem',
      outline: 'none'
    }
  };
};

var StyledLink = styled.a.withConfig({
  displayName: "Link__StyledLink",
  componentId: "sc-1bokult-0"
})(base$3, {
  '& svg': {
    transition: 'transform 150ms ease-in-out'
  },
  '&:hover svg': {
    transform: 'scale(1.1, 1.1)'
  },
  '&:active svg': {
    transform: 'scale(1, 1)'
  }
}, function (_ref2) {
  var invert = _ref2.invert,
      context = _ref2.context;

  if (context.inheritColor) {
    return {
      '&:link,&:visited': {
        color: 'inherit'
      }
    };
  }

  if (invert) {
    return {
      '&:link,&:visited': {
        color: colorWhite$1
      }
    };
  }

  return {};
}, states, function (_ref3) {
  var hasIcon = _ref3.hasIcon;

  if (hasIcon) {
    return {
      display: 'inline-block',
      '& > svg': {
        verticalAlign: 'bottom'
      }
    };
  }

  return {};
});
/**
 * @version ./package.json
 */

var Link = function Link(_ref4, context) {
  var reactRouterLinkComponent = _ref4.reactRouterLinkComponent,
      invert = _ref4.invert,
      children = _ref4.children,
      forwardedRef = _ref4.forwardedRef,
      Icon = _ref4.icon,
      iconPosition = _ref4.iconPosition,
      rest = objectWithoutProperties$2(_ref4, ["reactRouterLinkComponent", "invert", "children", "forwardedRef", "icon", "iconPosition"]);

  if (!(reactRouterLinkComponent && rest.to) && (reactRouterLinkComponent || rest.to)) {
    warn('Link', 'The props `reactRouterLinkComponent` and `to` must be used together.');
  }

  var renderChildren = useCallback(function () {
    if (Icon) {
      return React.createElement(React.Fragment, null, iconPosition === 'left' && React.createElement(Icon, {
        color: invert ? 'white' : 'greyShark',
        style: {
          marginRight: '0.5rem'
        }
      }), children, iconPosition === 'right' && React.createElement(Icon, {
        color: invert ? 'white' : 'greyShark',
        style: {
          marginLeft: '0.25rem'
        }
      }));
    }

    return children;
  }, [children, Icon, iconPosition, invert]);
  return React.createElement(StyledLink, _extends_1$6({}, safeRest(rest), {
    as: reactRouterLinkComponent || 'a',
    invert: invert,
    context: context,
    ref: forwardedRef,
    hasIcon: !!Icon
  }), renderChildren());
};

Link.propTypes = {
  /**
   * React Router Link component.
   */
  reactRouterLinkComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /**
   * Target URL (if using 'reactRouterLinkComponent')
   */
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),

  /**
   * Target URL.
   */
  href: PropTypes.string,

  /**
   * Invert link style to appear light on dark backgrounds.
   */
  invert: PropTypes.bool,

  /**
   * Link text.
   */
  children: PropTypes.node.isRequired,

  /**
   * @ignore
   */
  forwardedRef: PropTypes.object,

  /**
   * Provide an icon from the Dependent icon group in `@tds/core-interactive-icon`.
   * @since 2.2.0
   */
  icon: componentWithName('Dependent', true),

  /**
   * When `icon` is provided, use `iconPosition` to place the Icon to the left or right side of Link.
   * @since 2.2.0
   */
  iconPosition: PropTypes.oneOf(['left', 'right'])
};
Link.defaultProps = {
  reactRouterLinkComponent: null,
  to: null,
  href: null,
  invert: undefined,
  forwardedRef: undefined,
  icon: undefined,
  iconPosition: 'left'
};
Link.contextTypes = {
  inheritColor: PropTypes.bool
};
var Link$1 = withForwardedRef(Link);

var HEADER_LEVELS = {
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4'
};
var TEXT_SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
};
var BUTTON_RANKS = {
  MAIN: 'main',
  COMMON: 'common'
};
var CANCELLATION_BUTTON_TYPES = {
  BUTTON: 'button',
  LINK_WITH_ICON: 'linkWithIcon',
  LINK_WITHOUT_ICON: 'linkWithoutIcon'
};
var BUTTON_VARIANTS = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  INVERTED: 'inverted',
  STANDARD: 'standard',
  BRAND: 'brand',
  DANGER: 'danger'
};
var LINK_ICON_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};

var FullScreenOverlay = styled.div(function (props) {
  if (props && props.isOpen) {
    return _extends_1({
      display: 'flex',
      overflow: 'scroll',
      backgroundColor: colorWhite$2,
      width: '100%',
      height: '100%',
      maxHeight: '100vh',
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      zIndex: '1400'
    }, media.from('md').css({
      backgroundColor: 'rgba(255, 255, 255, 0.94)'
    }));
  }

  return null;
});
var StyledModal = styled.div(function (props) {
  var width = props.width;
  return _extends_1({
    height: '100%',
    width: '100%',
    position: 'relative',
    top: '0%',
    left: '0%',
    '> button:first-child': {
      display: 'flex',
      alignSelf: 'flex-end',
      background: 'none',
      border: 'none',
      margin: '1rem 0.5rem'
    }
  }, media.from('md').css({
    margin: 'auto',
    maxWidth: '736px',
    width: "".concat(width, "px"),
    minWidth: '570px',
    height: 'auto',
    maxHeight: '90vh',
    borderRadius: '0.25rem',
    boxShadow: '0 0 16px 0 rgba(0,0,0,0.2)',
    zIndex: '2000',
    backgroundColor: colorWhite$2
  }));
});
var CloseButtonWrapper = styled.div({
  float: 'right',
  padding: '1rem 1rem 0 0',
  position: 'absolute',
  right: '0%',
  top: '0%'
});
var ModalWrapper = styled.div({
  display: 'flex',
  flexFlow: 'column',
  justifyContent: 'space-between',
  height: '100%',
  '> div:first-child': {
    height: '100%',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'space-between'
  }
});
var HeaderWrapper = styled.div({});
var ContentWrapper = styled.div(function (_ref) {
  var offsetHeight = _ref.offsetHeight,
      showHeaderDivider = _ref.showHeaderDivider,
      showFooter = _ref.showFooter;
  var updatedHeight = showHeaderDivider ? offsetHeight : offsetHeight - 16;
  return _extends_1({
    margin: '0 -2rem',
    padding: '0 2rem',
    overflowY: 'scroll',
    overflowX: 'hidden',
    maxHeight: "calc(95vh - ".concat(updatedHeight, "px - 10rem)"),
    marginTop: 0
  }, media.from('xs').until('md').css({
    height: '100%',
    maxHeight: "calc(175vh - ".concat(updatedHeight, "px - ").concat(showFooter ? 6 : 5, "rem)")
  }));
});
var LinkWrapper = styled.div(_extends_1({
  cursor: 'pointer',
  marginTop: '1rem',
  '> a': {
    textDecoration: 'underline'
  }
}, media.from('xs').until('md').css({
  marginTop: 0,
  position: 'relative',
  marginLeft: 'auto',
  marginRight: 'auto'
})));
var FooterWrapper = styled.div(_extends_1({}, media.from('md').css({
  marginBottom: '-1rem'
})));
var HairlineDividerWrapper = styled.div({
  margin: '0 -2rem'
});

/* eslint-disable jsx-a11y/tabindex-no-positive */

var CancellationButton = function CancellationButton(handleClose, buttonType, text) {
  switch (buttonType) {
    case CANCELLATION_BUTTON_TYPES.LINK_WITH_ICON:
      return React.createElement(LinkWrapper, {
        tabIndex: "0"
      }, React.createElement(Link$1, {
        onClick: handleClose,
        icon: Delete,
        iconPosition: LINK_ICON_POSITIONS.RIGHT,
        "data-testid": "cancel-link"
      }, text));

    case CANCELLATION_BUTTON_TYPES.LINK_WITHOUT_ICON:
      return React.createElement(LinkWrapper, {
        tabIndex: "0"
      }, React.createElement(Link$1, {
        onClick: handleClose,
        "data-testid": "cancel-link"
      }, text));

    default:
      return React.createElement(Button, {
        variant: "danger",
        onClick: handleClose,
        "data-testid": "cancel-button",
        tabIndex: "0"
      }, text);
  }
};

var Footer = function Footer(_ref) {
  var cancelButtonText = _ref.cancelButtonText,
      cancelButtonType = _ref.cancelButtonType,
      confirmButtonText = _ref.confirmButtonText,
      confirmButtonVariant = _ref.confirmButtonVariant,
      handleClose = _ref.handleClose,
      handleConfirm = _ref.handleConfirm;
  return React.createElement(Box, {
    between: 3,
    inline: {
      xs: false,
      md: true
    }
  }, React.createElement(Button, {
    variant: confirmButtonVariant,
    rank: BUTTON_RANKS.MAIN,
    onClick: handleConfirm,
    "data-testid": "confirm-button",
    tabIndex: 0
  }, confirmButtonText), cancelButtonText && CancellationButton(handleClose, cancelButtonType, cancelButtonText));
};

Footer.propTypes = {
  cancelButtonText: PropTypes.string,
  cancelButtonType: PropTypes.oneOf(Object.values(CANCELLATION_BUTTON_TYPES)),
  confirmButtonText: PropTypes.string.isRequired,
  confirmButtonVariant: PropTypes.oneOf(Object.values(BUTTON_VARIANTS)),
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired
};
Footer.defaultProps = {
  cancelButtonText: '',
  cancelButtonType: CANCELLATION_BUTTON_TYPES.LINK_WITHOUT_ICON,
  confirmButtonVariant: BUTTON_VARIANTS.STANDARD
};

function createCommonjsModule$8(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _extends_1$7 = createCommonjsModule$8(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose$3 = _objectWithoutPropertiesLoose$3;

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var objectWithoutProperties$3 = _objectWithoutProperties$3;

var textColor = function textColor(_ref) {
  var invert = _ref.invert;
  return invert ? invertedColor : color;
};

var textInheritColor = function textInheritColor(_ref2) {
  var inheritColor = _ref2.inheritColor;
  return inheritColor ? {
    color: 'inherit'
  } : undefined;
};

var textSize = function textSize(_ref3) {
  var size = _ref3.size;
  return typography[size];
};

var textBold = function textBold(_ref4) {
  var bold = _ref4.bold,
      size = _ref4.size;
  return bold ? boldFont : typography["".concat(size, "Font")];
};

var textBlock = function textBlock(_ref5) {
  var block = _ref5.block;
  return block ? blockText : undefined;
}; // This named export is not guaranteed to be maintained and may be removed at any time.


var StyledText = styled.span.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-1m0rr67-0"
})(textColor, textInheritColor, textSize, textBold, textBlock, {
  sup: sup
});
/**
 * Inline text usually as an HTML `<span>` element.
 *
 * @version ./package.json
 */

var Text = function Text(_ref6, context) {
  var children = _ref6.children,
      size = _ref6.size,
      invert = _ref6.invert,
      rest = objectWithoutProperties$3(_ref6, ["children", "size", "invert"]);

  return React.createElement(DependentIconSizeContext.Provider, {
    value: {
      paragraphSize: size,
      invert: invert
    }
  }, React.createElement(StyledText, _extends_1$7({}, safeRest(rest), {
    size: size,
    invert: invert,
    inheritColor: context.inheritColor
  }), children));
};

Text.propTypes = {
  /**
   * If true, renders a block level element.
   * Otherwise, renders an inline element.
   */
  block: PropTypes.bool,

  /**
   * Embolden text without conveying any special importance or relevance.
   */
  bold: PropTypes.bool,

  /**
   * The font size.
   */
  size: PropTypes.oneOf(['base', 'small', 'medium', 'large']),

  /**
   * Invert the text color to appear light on dark backgrounds.
   */
  invert: PropTypes.bool,

  /**
   * The content. Can be text, other components, or HTML elements.
   */
  children: PropTypes.node.isRequired
};
Text.defaultProps = {
  block: false,
  bold: false,
  size: 'base',
  invert: false
};
Text.contextTypes = {
  inheritColor: PropTypes.bool
};

var Header = function Header(_ref) {
  var heading = _ref.heading,
      headingLevel = _ref.headingLevel,
      subHeading = _ref.subHeading,
      subHeadingSize = _ref.subHeadingSize;
  return React.createElement(Box, {
    between: 3,
    tabIndex: 0
  }, React.createElement(Box, {
    between: 3
  }, React.createElement(Heading, {
    level: headingLevel
  }, heading), subHeading && React.createElement(Text, {
    size: subHeadingSize
  }, subHeading)));
};

Header.propTypes = {
  heading: PropTypes.string.isRequired,
  headingLevel: PropTypes.oneOf(Object.values(HEADER_LEVELS)),
  subHeading: PropTypes.string,
  subHeadingSize: PropTypes.oneOf(Object.values(TEXT_SIZES))
};
Header.defaultProps = {
  headingLevel: HEADER_LEVELS.H3,
  subHeading: '',
  subHeadingSize: TEXT_SIZES.MEDIUM
};

var FocusTrap = withFocusTrap('div');
/**
 * @version ./package.json
 */

var Modal = function Modal(_ref) {
  var heading = _ref.heading,
      headingLevel = _ref.headingLevel,
      subHeading = _ref.subHeading,
      subHeadingSize = _ref.subHeadingSize,
      confirmButtonVariant = _ref.confirmButtonVariant,
      confirmCTAText = _ref.confirmCTAText,
      cancelButtonType = _ref.cancelButtonType,
      cancelCTAText = _ref.cancelCTAText,
      bodyText = _ref.bodyText,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm,
      focusElementAfterClose = _ref.focusElementAfterClose,
      width = _ref.width,
      showHeaderHairlineDivider = _ref.showHeaderHairlineDivider,
      showHeaderDimpleDivider = _ref.showHeaderDimpleDivider,
      showFooterHairlineDivider = _ref.showFooterHairlineDivider,
      rest = objectWithoutProperties(_ref, ["heading", "headingLevel", "subHeading", "subHeadingSize", "confirmButtonVariant", "confirmCTAText", "cancelButtonType", "cancelCTAText", "bodyText", "isOpen", "onClose", "onConfirm", "focusElementAfterClose", "width", "showHeaderHairlineDivider", "showHeaderDimpleDivider", "showFooterHairlineDivider"]);

  var _useState = useState(0),
      _useState2 = slicedToArray(_useState, 2),
      offsetHeight = _useState2[0],
      setOffsetHeight = _useState2[1];

  var ModalOverlayRef = useRef(null);
  var modalRef = useRef(null);
  var header = useRef(null);

  var handleClose = function handleClose(e) {
    if (focusElementAfterClose && focusElementAfterClose.current) {
      focusElementAfterClose.current.focus();
    }

    return onClose(e);
  };

  var handleKeyDown = function handleKeyDown(e) {
    var key = e.keyCode || e.key;

    if (key === 'Escape' || key === 27) {
      return handleClose(e);
    }

    return null;
  };

  var preventScroll = function preventScroll(e) {
    if (ModalOverlayRef.current.contains(e.targetTouches[0].target)) {
      e.preventDefault();
    }
  };

  var removeEventScrolling = function removeEventScrolling() {
    document.body.removeEventListener('touchmove', preventScroll);
    document.body.style.overflow = 'visible';
  };

  var handleOutSideClick = function handleOutSideClick(e) {
    if (!modalRef.current.contains(e.target)) {
      handleClose(e);
    }
  };

  useEffect(function () {
    if (isOpen) {
      document.body.addEventListener('touchmove', preventScroll, {
        passive: false
      });
      document.body.addEventListener('keydown', handleKeyDown, {
        passive: false
      });
      document.body.addEventListener('mousedown', handleOutSideClick, {
        passive: false
      });
      document.body.style.overflow = 'hidden';
      header.current.focus();
    } else {
      removeEventScrolling();
      document.body.removeEventListener('keydown', handleKeyDown);
      document.body.removeEventListener('mousedown', handleOutSideClick);
    }

    return function () {
      removeEventScrolling();
      document.body.removeEventListener('keydown', handleKeyDown);
      document.body.removeEventListener('mousedown', handleOutSideClick);
    };
  }, [isOpen]);
  useEffect(function () {
    var headerHeight = document.querySelector('#header-wrapper') ? document.querySelector('#header-wrapper').offsetHeight : 0;
    var footerHeight = document.querySelector('#footer-wrapper') ? document.querySelector('#footer-wrapper').offsetHeight : 0;
    setOffsetHeight(headerHeight + footerHeight);
  }, [isOpen]);
  var modalHeading = typeof heading === 'string' ? React.createElement(Header, {
    heading: heading,
    headingLevel: headingLevel,
    subHeading: subHeading,
    subHeadingSize: subHeadingSize
  }) : heading;
  var showHeaderDivider = showHeaderHairlineDivider || showHeaderDimpleDivider;
  var description = typeof bodyText === 'string' ? React.createElement(Paragraph, null, bodyText) : bodyText;
  return React.createElement(React.Fragment, null, isOpen && React.createElement(FocusTrap, null, React.createElement(FullScreenOverlay, _extends_1({
    "data-testid": "tds-modal-overlay"
  }, safeRest(rest), {
    isOpen: isOpen,
    ref: ModalOverlayRef
  }), React.createElement(StyledModal, {
    ref: modalRef,
    width: width
  }, React.createElement(ModalWrapper, null, React.createElement(Box, {
    inset: 4,
    between: 4
  }, React.createElement("div", {
    ref: header,
    tabIndex: "0"
  }, React.createElement(HeaderWrapper, {
    id: "header-wrapper"
  }, React.createElement(Box, {
    between: 3
  }, modalHeading, showHeaderHairlineDivider && React.createElement(HairlineDivider, null), showHeaderDimpleDivider && React.createElement(DimpleDivider, null)))), React.createElement(ContentWrapper, {
    offsetHeight: offsetHeight,
    showHeaderDivider: showHeaderDivider,
    showFooter: Boolean(confirmCTAText),
    tabIndex: "0"
  }, description), confirmCTAText && React.createElement(FooterWrapper, {
    id: "footer-wrapper"
  }, React.createElement(Box, {
    between: 3
  }, React.createElement(HairlineDividerWrapper, {
    decreaseMargin: showFooterHairlineDivider
  }, showFooterHairlineDivider && React.createElement(HairlineDivider, null)), React.createElement(Footer, {
    cancelButtonText: cancelCTAText,
    cancelButtonType: cancelButtonType,
    confirmButtonText: confirmCTAText,
    confirmButtonVariant: confirmButtonVariant,
    handleClose: handleClose,
    handleConfirm: onConfirm
  })))), React.createElement(CloseButtonWrapper, null, React.createElement(IconButton, {
    icon: Close,
    onClick: handleClose,
    a11yText: "Close",
    tabIndex: "0"
  })))))));
};

Modal.propTypes = {
  /**
   * Text that will appear at the top of the content section.
   */
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /**
   * The visual level of the heading.
   */
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4']),

  /**
   * Text that will appear underneath the heading.
   */
  subHeading: PropTypes.string,

  /**
   * Size of the subheading text.
   */
  subHeadingSize: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   *
   * Text that will appear in the middle of the content section.
   */
  bodyText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,

  /**
   *
   * Set the variant of the confirm button
   */
  confirmButtonVariant: PropTypes.oneOf(['inverted', 'standard', 'brand', 'danger']),

  /**
   *
   * Text that represents confirm CTA.
   */
  confirmCTAText: PropTypes.string,

  /**
   *
   * Text that represents cancel CTA or closing modal action.
   */
  cancelButtonType: PropTypes.oneOf(['button', 'linkWithIcon', 'linkWithoutIcon']),

  /**
   *
   * Text that represents cancel CTA or closing modal action.
   */
  cancelCTAText: PropTypes.string,

  /**
   *
   * Boolean variable that controls open and closed state of modal.
   */
  isOpen: PropTypes.bool.isRequired,

  /**
   *
   * Use this prop to change the value of `isOpen` when the customer clicks the cancel button, close button, background, or hits the escape key.
   * Modal will also call the ref passed to `focusElementAfterClose` to set focus to it, as `ref.current.focus()`.
   *
   * Do not use this handler to perform account-related actions for the customer.
   */
  onClose: PropTypes.func.isRequired,

  /**
   *
   * Handler Function used to proceed with modal CTA.
   */
  onConfirm: PropTypes.func,

  /**
   *
   * Accepts a React Element's Ref, in order to focus on it after modal closes. Modal will call your ref as `ref.current.focus()`
   * when the Modal closes.
   *
   * We recommend passing the Ref of the button that was used to open the Modal.
   */
  focusElementAfterClose: PropTypes.oneOfType([PropTypes.shape({
    current: PropTypes.any
  })]).isRequired,

  /**
   * Set the width of `Modal`.
   * Accepts a numeric value that lies in the range between minWidth(570) - maxWidth(736).
   */
  width: PropTypes.number,

  /**
   *
   * Show the hairline divider underneath the heading.
   */
  showHeaderHairlineDivider: PropTypes.bool,

  /**
   *
   * Show the hairline divider underneath the heading.
   */
  showHeaderDimpleDivider: PropTypes.bool,

  /**
   *
   * Show the hairline divider above the footer.
   */
  showFooterHairlineDivider: PropTypes.bool
};
Modal.defaultProps = {
  headingLevel: 'h3',
  subHeading: '',
  subHeadingSize: 'medium',
  confirmButtonVariant: 'standard',
  confirmCTAText: '',
  cancelButtonType: 'linkWithoutIcon',
  cancelCTAText: '',
  width: 570,
  onConfirm: null,
  showHeaderHairlineDivider: true,
  showHeaderDimpleDivider: false,
  showFooterHairlineDivider: true
};

export default Modal;
